module.exports = __webpack_public_path__ + "c27d32294fa37788cab39c153f51de6e.pdf";